import React from 'react';
import { gradientAnimationStyle } from './styles';

/**
 * Component to inject gradient animation styles into the document head
 * This component renders a style tag with the CSS animation definitions
 */
export const GradientAnimationStyles: React.FC = () => (
  <style dangerouslySetInnerHTML={{ __html: gradientAnimationStyle }} />
);

export default GradientAnimationStyles;
